import { contactOf, useSiteConfig } from "../hooks/use-site-config";
import { reachOutLabel } from "../utils/labels";
import { card, figure } from "./section";
import { cn } from "@/lib/utils";

/**
 * A page whose list the trainer has not filled yet: one line saying so, and the way to reach
 * them if the page has one.
 */
export const EmptyCard = ({ title, body }: { title: string; body?: string }) => {
  const contact = contactOf(useSiteConfig());

  return (
    <div className={cn(card, "mt-3 flex flex-col items-center px-6 py-16 text-center")}>
      <p className="text-[22px] font-semibold tracking-[-0.02em]">{title}</p>
      <p className="mt-1 text-muted-foreground">{body ?? reachOutLabel(contact)}</p>
      {contact ? (
        <a
          href={contact.href}
          className={cn(
            figure,
            "mt-6 rounded-lg text-[clamp(1.75rem,5vw,2.75rem)] break-all outline-none focus-visible:ring-2 focus-visible:ring-ring",
          )}
        >
          {contact.label}
        </a>
      ) : null}
    </div>
  );
};
